module.exports = __webpack_public_path__ + "assets/5f8b6d3ceba78516c95f4d9c694e02ee.svg";